import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function homeRCTIReducer(state = initialState.home, action) {
  switch (action.type) {
    case types.LIST_COLLECTION_HISTORY:
      return {
        ...state,
        collectionHistory: action.items,
      };
    case types.CLEAR_COLLECTION_HISTORY:
      return {
        ...state,
        collectionHistory: [],
      };
    case types.LIST_CLIENT_LOCATIONS:
      return {
        ...state,
        clientLocations: action.items,
      };
    case types.CLEAR_CLIENT_LOCATIONS:
      return {
        ...state,
        clientLocations: [],
      };
    case types.LIST_CLIENT_LOCATIONS_DELIVERY:
      return {
        ...state,
        clientLocationsDelivery: action.items,
      };
    case types.CLEAR_CLIENT_LOCATIONS_DELIVERY:
      return {
        ...state,
        clientLocationsDelivery: [],
      };
    default:
      return state;
  }
}
